module.exports = __webpack_public_path__ + "static/media/arrowLeft.40ee1e1c.svg";